
import {NavLink} from "react-router-dom";

function Link(props) {

    let element = null, attributes = "";
    props = props.data;
    let icon_class = "";
    if(props.hasOwnProperty("icon"))
        icon_class = (<i className={props.icon}/>);
    if(props.hasOwnProperty("attributes"))
        attributes = props.attributes;

    switch (props.type) {
        case "button":
            element = (<button className={props.className} {...attributes} onClick={props.handleClick} disabled={props.disabled} >{props.iconFirst ? icon_class : ""} {props.label} {!props.iconFirst ? icon_class : ""}</button>);
            break;
        case "a":
            element = (<a href={props.href} className={props.className} {...attributes} onClick={props.handleClick}>{props.iconFirst ? icon_class : ""} {props.label} {!props.iconFirst ? icon_class : ""}</a>);
            break;
        case "NavLink":
            element = (<NavLink to={props.href} className={props.className} {...attributes} onClick={props.handleClick}>{props.iconFirst ? icon_class : ""} {props.label} {!props.iconFirst ? icon_class : ""} </NavLink>);
            break;
    }
    return element;
}

export default Link;